import StageHeader from "components/StageHeader";
import { CalibrationDashboardTab } from "components/shared/features";
import PageStage from "components/stages/PageStage";

export const CalibrationTrackingPage = () => {
  return (
    <PageStage>
      <StageHeader
        title="Calibration Tracking"
        subtitle="Track calibration status, expiry dates, and upload certificates for all calibrated tools."
      />
      <CalibrationDashboardTab />
    </PageStage>
  );
};
